import { BOOKMARK } from '../actions/BookmarkActions'

function initialState() {
  return null
}

export default function bookmark(state = initialState(), action) {
  switch (action.type) {
    case BOOKMARK:
      return action.payload
    default:
      return state
  }
}
